import * as React from 'react';

import { MdClose } from 'react-icons/md';
import { Link } from 'react-router-dom';

import styles from './fullscreen-modal-header.scss';
import { LocationDescriptorObject } from 'history';
import { ReactNode } from 'react';

export interface FullscreenModalHeaderProps {
  componentId?: string;
  children?: ReactNode;
  previousUrl?: LocationDescriptorObject;
  onClose?: () => void;
}

export const FullscreenModalHeader = (props: FullscreenModalHeaderProps) => {

  const onClose = (e: React.MouseEvent<any, MouseEvent>) => {
    if (props.onClose) {
      e.preventDefault();
      e.stopPropagation();

      props.onClose();
    }
  };
  return (
    <div className={`${styles.header} container`}>
      <div className={`main-grid ${styles.info} info`}>
        {props.children}
      </div>
      <Link to={props.previousUrl ?? '/'} onClick={onClose} className={`btn ${styles.closeButton}`} aria-label="Close dialog window">
        <MdClose />
      </Link>
    </div>
  );
};
